<template>
  <div class="print-data-block-holder">
    <div class="pdb-element">
      <div class="pdb-label">Record</div>
      <div class="pdb-record pdb-value">{{ getRecordNum }}</div>
    </div>
    <div class="pdb-element">
      <div class="pdb-label">Date</div>
      <div class="pdb-date pdb-value">{{ getRecordDate }}</div>
    </div>
    <div class="pdb-element">
      <div class="pdb-label">Requested By</div>
      <div class="pdb-title pdb-value">{{ getRequestedBy }}</div>
    </div>
    <div class="pdb-element">
      <div class="pdb-label">Performed By</div>
      <div class="pdb-title pdb-value">{{ getPerformedBy }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrintDataBlock',
  props: ['record'],
  computed: {
    getRecordNum () {
      return this.$props.record.testRecordNumber;
    },
    getRecordDate () {
      return this.$props.record.testDateUtc;
    },
    getRequestedBy () {
      return this.$props.record.requestedBy;
    },
    getPerformedBy () {
      return this.$props.record.performedBy;
    },
  },
};
</script>

<style scoped>
.print-data-block-holder {
  display: flex;
  flex-direction: column;
}
.pdb-element {
  display: flex;
  height: 22px;
  margin-left: 20px;
}
.pdb-label {
  font-weight: 600;
  display: flex;
  justify-content: flex-end;
  border-bottom: 0.5px solid #adadad;
  font-size: 80%;
  padding-right: 8px;
  border-right: 0.5px solid #adadad;
}
.pdb-record {
  color: #39b54a;
}
.pdb-date {
  color: #0088ca;
}
.pdb-value {
  font-weight: 600;
  display: flex;
  justify-content: flex-start;
  border-bottom: 0.5px solid #adadad;
  font-size: 80%;
  padding-left: 8px;
}
</style>
